import {ScoringSystem, ScoringSystemId} from '@legit.health/ui';
import {ConditionInfo} from '../../../types';

export default function getScoringSystemsAnswers({
  conditionInfo,
  scoringSystemsById
}: {
  conditionInfo: ConditionInfo;
  scoringSystemsById: Record<ScoringSystemId, ScoringSystem>;
}) {
  const answers: Record<string, Record<string, string | null>> = {};
  for (const index in conditionInfo.scoringSystemsIds) {
    const scoringSystemId = conditionInfo.scoringSystemsIds[index] as number;
    const scoringSystem = scoringSystemsById[scoringSystemId];
    if (scoringSystem) {
      answers[scoringSystem.id] = scoringSystem.items
        .filter((ssitem) => ssitem.question)
        .reduce(
          (acc, scoringSystemItem) => ({
            ...acc,
            [scoringSystemItem.id]: null
          }),
          {}
        );

      const scoringSystemAnswers = conditionInfo.answers[scoringSystem.id];
      for (const scoringSystemItemId in scoringSystemAnswers) {
        const text = `${scoringSystemAnswers[scoringSystemItemId]}`;
        (answers[scoringSystem.id] as Record<string, string | null>)[scoringSystemItemId] = text;
      }
    }
  }
  return answers;
}
